import { render, staticRenderFns } from "./AddMujer.vue?vue&type=template&id=69ea8485"
import script from "./AddMujer.vue?vue&type=script&lang=js"
export * from "./AddMujer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports